export const getProductStatus = (record) => {
    let productStatus = '';
    if(record?.inwardXflow === true){
        productStatus += (record?.xflowAccountCreationStatus ? "X -" + record?.xflowAccountCreationStatus.replaceAll("_", " ") : "");
    }
    if(record?.inwardPayglocal === true){
        if (productStatus) {
            productStatus += " | ";
        }
        productStatus += (record?.payglocalAccountCreationStatus ? "P -" + record?.payglocalAccountCreationStatus.replaceAll("_", " ") : "");
    }
    return productStatus || "-";
}